import React, {Component} from 'react';
import { Hammer } from 'react-bootstrap-icons';

class UnderConstructionComponent extends React.Component {
    render() {
        return (
          <div className="mt-4 text-center">
            <Hammer size={64} className="mb-1 mr-1 text-info" />
            <div className="mt-2">Under Construction</div>
          </div>
        );
    }
}

export default UnderConstructionComponent;